export default __webpack_public_path__ + "static/media/background2.74452fd0.png";